<div class="container">
    <div class="summary-header side">
        <div class="select-templates" [ngClass]="{'select-user':recipientsToFilterId$()}" *ngIf="fromSummary" #trigger
            (click)="isFilterRecipientsOpen=true">
            <p translate *ngIf="recipientsToFilterId$()==undefined">data.summary.allComments
            </p>
            <ng-container *ngFor="let r of recipientsGroupbyUsers$()">
                <div *ngIf="recipientsToFilterId$()==r.user.id" class="contact">
                    <div class="circle">
                        <p> {{ r.user.firstName ? r.user.firstName.charAt(0).toUpperCase() : '' }}</p>
                        <p>{{ r.user.lastName ? r.user.lastName.charAt(0).toUpperCase() : '' }}</p>
                    </div>
                    <div class="name">
                        <p>{{r.user.firstName}} {{r.user.lastName}}</p>
                    </div>
                </div>
            </ng-container>

            <img src="/assets/images/select.svg">
            <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger"
                [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="isFilterRecipientsOpen=false"
                [cdkConnectedOverlayOpen]="isFilterRecipientsOpen" cdkConnectedOverlayBackdropClass="backdrop-selection"
                [cdkConnectedOverlayPositions]="positonArea">
                <div class="overlay-warp">
                    <div class="item" (click)="filterByRecipient(undefined)"
                        [ngClass]="{'current':(recipientsToFilterId$()==undefined)}">
                        <p translate>data.summary.allComments</p>
                    </div>
                    <div class="item" *ngFor="let r of recipientsGroupbyUsers$()" (click)="filterByRecipient(r.user.id)"
                        [ngClass]="{'current':(recipientsToFilterId$()==r.user.id)}">
                        <div class="contact">
                            <div class="circle">
                                <span> {{ r.user.firstName ? r.user.firstName.charAt(0).toUpperCase() : '' }}</span>
                                <span>{{ r.user.lastName ? r.user.lastName.charAt(0).toUpperCase() : '' }}</span>
                            </div>
                            <div class="name">
                                <p>{{r.user.firstName}} {{r.user.lastName}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
        <div class="select-templates select-question" *ngIf="recipientsToFilterId$()!=undefined && filterFieldQuestionsData$()" #triggerQuestion (click)="isFilterQuestionOpen=true">
            <ng-container *ngIf="!selectedQuestionId$()">
                <p translate>data.summary.filteredBy</p>
                <p>{{selectedFilterSubmissionOption$()?.label ?? filterFieldQuestionsData$()?.titleToData}}</p>
            </ng-container>

            <ng-container *ngIf="selectedQuestionId$()">
                <p translate>data.summary.filteredBy</p>
                <ng-container *ngFor="let q of filterFieldAnswersData$()">
                    <p *ngIf="q.recipient">{{q}}</p>
                </ng-container>
            </ng-container>

            <img src="/assets/images/select.svg">

            <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="triggerQuestion"
                [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="isFilterQuestionOpen=false"
                [cdkConnectedOverlayOpen]="isFilterQuestionOpen" cdkConnectedOverlayBackdropClass="backdrop-selection"
                [cdkConnectedOverlayPositions]="positonArea">

                <div class="overlay-warp">
                    <!-- "All questions" option (clear filter) -->
                    <div class="item" (click)="filterBySubmission(undefined)"
                        [ngClass]="{'current': recipientIdToFilter$() == null}">
                        <p translate>data.summary.allAnswers</p>
                    </div>

                    <div class="item" *ngFor="let opt of filterFieldSubmissionOptions$()"
                        (click)="filterBySubmission(opt.recipientId)"
                        [ngClass]="{'current': recipientIdToFilter$() === opt.recipientId}">
                        <p>{{ opt.label }}</p>
                    </div>


                </div>
            </ng-template>
        </div>

        <div class="select-templates" *ngIf="!fromSummary" #trigger (click)="isFilterOpen=true">
            <ng-container *ngIf="filter$()==eReplyStatus.InProgress">
                <p translate>data.submissions.partial</p>
                <p>({{amountPartial$ | async}})</p>
            </ng-container>
            <ng-container *ngIf="filter$()==eReplyStatus.Finished">
                <p translate>data.submissions.complete</p>
                <p>({{amountComplete$ | async}})</p>
            </ng-container>
            <ng-container *ngIf="filter$()==undefined">
                <p translate>data.submissions.everything</p>
                <p>({{amountAll$ | async}})</p>
            </ng-container>
            <img src="/assets/images/select.svg">
            <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger"
                [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="isFilterOpen=false"
                [cdkConnectedOverlayOpen]="isFilterOpen" cdkConnectedOverlayBackdropClass="backdrop-selection"
                [cdkConnectedOverlayPositions]="positonArea">
                <div class="overlay-warp">
                    <div class="item" (click)="filterByStatusReply(undefined)"
                        [ngClass]="{'current':(filter$()==undefined)}">
                        <p translate>data.submissions.everything</p>
                        <p>({{amountAll$ | async}})</p>
                    </div>
                    <div class="item" (click)="filterByStatusReply(eReplyStatus.Finished)"
                        [ngClass]="{'current':(filter$()==eReplyStatus.Finished)}">
                        <p translate>data.submissions.complete</p>
                        <p>({{amountComplete$ | async}})</p>
                    </div>
                    <div class="item" (click)="filterByStatusReply(eReplyStatus.InProgress)"
                        [ngClass]="{'current':(filter$()==eReplyStatus.InProgress)}">
                        <p translate>data.submissions.partial</p>
                        <p>({{amountPartial$ | async}})</p>
                    </div>
                </div>
            </ng-template>
        </div>
        <div class="compare" *ngIf="isQuestionnarieParent$()">
            <p translate>data.summary.compare</p>
            <div class="toggle on pointer" *ngIf=" showComparison$() else toggleOff" (click)="toggle(false)">
                <div class="toggle-warp">
                    <div class="warp-circle">
                        <svg-icon svgClass="svg-img-stroke-mini "
                            src="/assets/images/options/warp-toggle-on.svg"></svg-icon>
                    </div>
                    <div class="circleT on">
                        <svg-icon svgClass="svg-img-mini" src="/assets/images/options/toggle-on.svg"></svg-icon>
                    </div>
                </div>
            </div>

        </div>
        <ng-template #toggleOff>
            <div class="toggle off pointer" (click)="toggle(true)">
                <div class="toggle-warp">
                    <img class="warp-circle" src="/assets/images/options/warp-toggle-of.svg">
                    <img class="circleT" src="/assets/images/options/toggle-off.svg">
                </div>
            </div>
        </ng-template>
    </div>
    <!-- <que-stepper *ngIf="stepsNames$()" [stepsNames]="stepsNames$()!" [currentStep]=" currentStep$()" [isData]="true"
        (ChangeStepEvent)="changePage($event)"></que-stepper> -->
    <div class="side">
    </div>

</div>
<div class="warp-tow-title">
    <div class="side-title">
        <p *ngIf="(showComparison$())" translate>data.currentQuestionaire</p>
        <div class="select-questionnaires">
            <p>{{(questionnarieDetails$())?.name}} {{(questionnarieDetails$())?.createdDate| queDate}}
            </p>
        </div>
    </div>
    <div class="side-title">
        <p *ngIf="(showComparison$())" translate>data.previousQuestionaire</p>
        <div class="select-questionnaires" *ngIf="(showComparison$())">
            <p>{{(questionnarieParentDetails$())?.name}} {{(questionnarieParentDetails$())?.createdDate | queDate }}</p>
        </div>
    </div>
</div>